module.exports = __webpack_public_path__ + "static/media/hilda1.cfb1a2a6.jpg";